<template>
  <!--
    @TODO comment from PR (Esma):
    Maybe not for now, but DsGrid has the support for a portion that has different widths for different sizes
    Check the title and titleWidth props in DsGrid
    It is added to prevent applying all these grid classes by hand
  -->
  <div class="ds-container ds-md-padding-top-48 ds-padding-top-24">
    <div class="ds-grid ds-md-margin-bottom-48 ds-margin-bottom-0">
      <div class="ds-grid__col ds-grid__col--12 ds-md-grid__col--12 ds-lg-grid__col--8">
        <DsCardBlog
          class="ds-margin-bottom-48"
          :tag="firstArticle.tag"
          :title="firstArticle.title"
          :subtitle="`${firstArticle.dateFormatted} · ${t('minutesAmount', firstArticle.minutesToRead)}`"
          :image="firstArticleImage"
          :image-with-sizes="firstArticleImage"
          :link="firstArticle.link"
        />
      </div>
      <div class="ds-grid__col ds-grid__col--12 ds-md-grid__col--12 ds-lg-grid__col--4">
        <div class="ds-grid md-only-n-mx-12">
          <div
            v-for="(item, index) in remainingArticles"
            :key="item.slug"
            class="ds-grid__col ds-grid__col--12 ds-md-grid__col--6 ds-lg-grid__col--12 ds-padding-bottom-24 ds-only-sm-grid__col--no-gutter"
          >
            <DsCardBlog
              class="ds-margin-bottom-24"
              :tag="item.tag"
              :title="item.title"
              :subtitle="`${item.dateFormatted} · ${t('minutesAmount', item.minutesToRead)}`"
              :link="item.link"
            />
            <DsDivider
              v-if="index < remainingArticles.length - 1"
              class="ds-hidden-false ds-lg-hidden--false"
              :class="{ 'ds-md-hidden': index === 2 }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="wds-grid">
      <div class="wds-grid__col--12 ds-only-sm-grid__col--no-gutter">
        <DsDivider />
      </div>
    </div>
  </div>
</template>
<script setup>
import { DsCardBlog, DsDivider } from 'awds'
import mapperImage from '../../../core/data-layer/utils/mappers/mapper-image'

const { t } = useI18n()

const props = defineProps({
  highlightedArticles: {
    type: Array,
    default: () => []
  }
})

const firstArticle = computed(() => {
  return props.highlightedArticles?.[0]
})

const firstArticleImage = computed(() => {
  const imageSizes = {
    small: { width: 327, height: 184, aspectRatio: '16/9' },
    medium: { width: 672, height: 378, aspectRatio: '16/9' },
    large: { width: 784, height: 441, aspectRatio: '16/9' }
  }
  const image = mapperImage(firstArticle.value?.imageWithSizes?.original, imageSizes)
  return image
})

const remainingArticles = computed(() => {
  return props.highlightedArticles.slice(1)
})
</script>
<style lang="scss" scoped>
@import 'awds/foundation-mixins.scss';
@import 'awds/foundation-vars.scss';

.md-only-n-mx-12 {
  @include wds-screen-only-medium {
    margin-left: -#{$spacing-12};
    margin-right: -#{$spacing-12};
  }
}
</style>
